import firebase from 'firebase/app'
import 'firebase/auth'
import store from '../store'
import { SET_USER } from '../store/actions'
 

export const registerFirebase = () => {
	var firebaseConfig = {
		apiKey: 'AIzaSyDJdG6y9XNwjuRZEXe-lATPgYkFwu15Flg',
		authDomain: 're121-ac084.firebaseapp.com',
		databaseURL: 'https://re121-ac084.firebaseio.com',
		projectId: 're121-ac084',
		storageBucket: 're121-ac084.appspot.com',
		messagingSenderId: '835072558599',
		appId: '1:835072558599:web:406bd62acae048da'
	}

	// Initialize Firebase
	firebase.initializeApp (firebaseConfig)

	// Set auth state listener
	firebase.auth ().onAuthStateChanged (user => {
		store.commit (SET_USER, user)
	})
}